import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { NetworkService } from '../../shared/network.service';
@Injectable({
  providedIn: 'root'
})
export class CircleService {
  private pageChange = new BehaviorSubject('false');
  currentPage = this.pageChange.asObservable();

  constructor(private networkService: NetworkService,
    ) { }

  createCircle(body:any) {
    return this.networkService.post("api/circles",body, null,'bearer');
  }
 putCircle(body:any) {
    return this.networkService.put("api/circles",body, null,'bearer');
  }
  getMemberList() {
    return this.networkService.get("api/users",null, null,'bearer');
  }
  getUnreadCount() {
    return this.networkService.get("api/chats/unreadCount",null, null,'bearer');
  }
  
  resetpassword(req: any) {
    return this.networkService.post("api/user/verify/password/forgot", req, null, null);
  }

  getUserProfileApi(req:any) {
    return this.networkService.get("api/users/userList?userId=" + req, null,null, 'bearer');
  }

  uploadImage(image: any) {
    const formData = new FormData();
    formData.append("file",image);
    return this.networkService.uploadImages("api/s3upload/media-upload", formData, null, "bearer");
  }
  getMyCircleApi(circleid:any) {
    return this.networkService.get("api/circles/myCircles?circleId="+circleid,null, null,'bearer');
  }
  getYourOwnCircle() {
    return this.networkService.get("api/circles/myCircles",null, null,'bearer');
  }
  getRequestedCircle() {
    return this.networkService.get("api/circleRequests?type=received",null, null,'bearer');
  }
  getSentRequestedCircle() {
    return this.networkService.get("api/circleRequests?type=sent",null, null,'bearer');
  }
  getSentRequestedByCircle(query) {
    return this.networkService.get("api/circleRequests?type=sent"+query,null, null,'bearer');
  }
  getCircleMembers(circleId:any) {
    return this.networkService.get("api/circles/members?circleId="+circleId,null, null,'bearer');
  }

  getCircleHideExternalUsersMembers(circleId:any) {
    return this.networkService.get("api/circles/members?hideExternalUsers=true&circleId="+circleId,null, null,'bearer');
  }
  getGroupAllMembers(query:any) {
    return this.networkService.get("api/circleGroups/members?"+query,null, null,'bearer');
  }
  getAddMemberUserlist(query:any) {
    return this.networkService.get("api/users/list/lite?"+query,null, null,'bearer');
  }

  cancelRequest(body:any) {
    return this.networkService.put("api/circleRequests",body, null,'bearer');
  }
  createConnetion(body:any) {
    return this.networkService.post("api/connectionRequests",body, null,'bearer');
  }
  removeConnetion(id:any) {
    return this.networkService.delete("api/connections/"+id,null, null,'bearer');
  }
 
    
  deleteCircle(Id) {
    return this.networkService.delete("api/circles/"+Id,null, null,'bearer');
  }
  removeCircle(body) {
    return this.networkService.put("api/circles/leaveCircle/",body, null,'bearer');
  }
  removeMemberApi(body) {
    return this.networkService.put("api/circles/removeMember/",body, null,'bearer');
  }
  getUserDropDown(query:any){
    return this.networkService.get("api/users/userList?hideSelf=true&"+query,null, null,'bearer');
  }

  getConnectionListApi(query:any){
    
    return this.networkService.get("api/connections?"+query,null, null,'bearer');
  }


  inviteMemberRequestSend(req: any) {
    return this.networkService.post("api/circleRequests", req, null, null);
  }
  inviteMemberInternalExternalEmailApi(req: any) {
    return this.networkService.post("api/circleRequests/email", req, null, null);
  }

  changeMemberTypeApi(req:any) {
    return this.networkService.put("api/circles/updateMember", req, null, "bearer");
  }

  getCircleActivityApi(req:any) {
    return this.networkService.get("api/circles/activities?circleId="+req,null, null, "bearer");
  }
  getCircleCollobsDoc(req:any) {
    return this.networkService.get("api/etherpads?circleId="+req,null, null, "bearer");
  }
  createCollabsDoc(body) {
    return this.networkService.post("api/etherpads",body, null,'bearer');
  }
  updateCollabsDoc(body) {
    return this.networkService.put("api/etherpads",body, null,'bearer');
  }
  deleteCollabsDocApi(query) {
    return this.networkService.delete("api/etherpads/"+query,null, null,'bearer');
  }


  
  getAllEventListApi(query) {
    return this.networkService.get("api/events?"+query,null, null,'bearer');
  }
  attachmentCateory(query) {
    return this.networkService.get("api/dropdowns/circleCategories"+query,null, null,'bearer');
  }
  attachmentCateoryForAddModal(query) {
    return this.networkService.get("api/dropdowns/attachmentCategories?"+query,null, null,'bearer');
  }

  getCategoryDropDownList(query) {
    return this.networkService.get("api/circleAttachments/categories/write/access?"+query,null, null,'bearer');
  }

  getCategoryListingApi(query) {
    return this.networkService.get("api/circleAttachments/categories/access?"+query,null, null,'bearer');
  }


  getAttachmentApi(query) {
    return this.networkService.get("api/circleAttachments?"+query,null, null,'bearer');
  }

  getSessionId(query) {
    return this.networkService.get("api/circleAttachments/sessionID?"+query,null, null,'bearer');
  }

  postAttachmentDownload(body) {
    return this.networkService.post("api/circleAttachments/inc/download/count",body, null,'bearer');
  }


  
  createAttachmentApi(body) {
    return this.networkService.post("api/circleAttachments",body, null,'bearer');
  }
  updateAttachmentApi(body) {
    return this.networkService.put("api/circleAttachments",body, null,'bearer');
  }

  updateFolderApi(body) {
    return this.networkService.put("api/circleAttachments/categories",body, null,'bearer');
  }

  deleteAttachmentApi(query) {
    return this.networkService.delete("api/circleAttachments/"+query,null, null,'bearer');
  }
  uploadPdf(image: any) {
    const formData = new FormData();
    formData.append("file",image);
    return this.networkService.uploadImages("api/s3upload/media-upload", formData, null, "bearer");
  }
  getChatSummary(query) {
    return this.networkService.get("api/chats/summary?"+query,null, null,'bearer');
  }
  getIndivialChat(query) {
    return this.networkService.get("api/chats/individual?"+query,null, null,'bearer');
  }
  getJoinedCircle(query) {
    return this.networkService.get("api/circles/myCircles?"+query,null, null,'bearer');
  }
  getpublicCircle(query) {
    return this.networkService.get("api/circles/circleList?"+query,null, null,'bearer');
    
  }
  getMutualCircle(query) {
    return this.networkService.get("api/circles/mutualCircles?"+query,null, null,'bearer');
  }
  getcirclehubReply(query){
    return this.networkService.get("api/chats/replies?"+query,null, null,'bearer');
    
  }
  UpdateConnetion(body:any) {
    return this.networkService.put("api/connectionRequests",body, null,'bearer');
  }
 
  circleJoin(body) {
    return this.networkService.post("api/circles/join",body, null,'bearer');
  }

  getAllCircleNotification(query) {
    return this.networkService.get("api/circles/dashboardActivities?"+query,null, null,'bearer');
  }
  getUserProfileCircleActivity(query) {
    return this.networkService.get("api/users/recentActivity?"+query,null, null,'bearer');
  }
  getmutualCircleMember(circleId) {
    return this.networkService.get("api/circles/mutualMembers?limit=100&circleId="+circleId,null, null,'bearer');
  }
  getmutualUserMember(userId) {
    return this.networkService.get("api/users/mutualMembers?limit=100&userId="+userId,null, null,'bearer');
  }
  createRequestInfo(body) {
    return this.networkService.post("api/circleInfoRequest",body, null,'bearer');
  }
  
  getRequestInfoSummay(query) {
    return this.networkService.get("api/circleInfoRequest/summary?"+query,null, null,'bearer');
  }
   getRequestInfoIndvidual(conversationId) {
    return this.networkService.get("api/circleInfoRequest/individual?conversationId="+conversationId,null, null,'bearer');
  }
  replyRequestInfoMessage(body) {
    return this.networkService.post("api/circleInfoRequest/reply",body, null,'bearer');
  }
  getNotification() {
    return this.networkService.get("api/users/isSeenData",null, null,'bearer');
  }
  getNotification1(query) {
    return this.networkService.get("api/users/isSeenData?"+query,null, null,'bearer');
  }
  

  changePassword( body:any) {
    return this.networkService.post("api/auth/password/change",body, null,'bearer');
  }
    
  deleteRequestInfo(conversationId) {
    return this.networkService.delete("api/circleInfoRequest/"+conversationId,null, null,'bearer');
  }
  DeleteReplyCirleHub(id) {
    return this.networkService.delete("api/chats/message/"+id,null, null,'bearer');
  }
  getEventListDropDownApi() {
    return this.networkService.get("api/dropdowns/eventTypes",null, null,'bearer');
  }
  getCircleGroupList(circleId:any) {
    return this.networkService.get("api/circleGroups/myGroups?circleId="+circleId,null, null,'bearer');
  }
  getGroupChatList(query) {
    return this.networkService.get("api/chats/individual?"+query,null, null,'bearer');
  }
  getPatientsList(query) {
    return this.networkService.get("tuftsapi/patients?"+query,null, null,'bearer');
  }
  getStudiesList(query) {
    return this.networkService.get("tuftsapi/studies/list/lite?"+query,null, null,'bearer');
  }
  getAddMemberUserList(query) {
    return this.networkService.get("api/users/list/lite?"+query,null, null,'bearer');
  }
  removeMember(body) {
    return this.networkService.put("api/circleGroups/remove/member",body, null,'bearer');
  }
  addMemberss( body:any) {
    return this.networkService.post("api/circleGroups/add/member",body, null,'bearer');
  }
  getSearchedBar(query) {
    return this.networkService.get("api/chats/search?"+query,null, null,'bearer');
  }
  getStudiesListBar(query) {
    return this.networkService.get("api/circles/myCircles?"+query,null, null,'bearer');
  }
  getStudiesListBarV1(query) {
    return this.networkService.get("api/circles/myCircles/v1?"+query,null, null,'bearer');
  }
  postChatBookmark(body: any) {
    return this.networkService.post("api/chats/bookmarks", body, null,'bearer');
  }
  getChatBookmark(query: any) {
    return this.networkService.get("api/chats/bookmarks?"+query,null, null,'bearer');
  }
  getStudyAPI(query:any,body:any) {
    return this.networkService.post("tuftsapi/studies?"+query,body, null, null);
  }
  getInitialSearchSuggestions(query:any) {
    return this.networkService.get("api/chats/search/suggestions?"+query, null, null, 'bearer');
  }
}

